import { render, staticRenderFns } from "./NewAiRobotNewPurchase.vue?vue&type=template&id=3411016f&"
import script from "./NewAiRobotNewPurchase.vue?vue&type=script&lang=js&"
export * from "./NewAiRobotNewPurchase.vue?vue&type=script&lang=js&"
import style0 from "./NewAiRobotNewPurchase.vue?vue&type=style&index=0&id=3411016f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports